import React from 'react'
import patternSelectors from '../../../../store/selectors/pattern.selectors'
import { useSelector } from 'react-redux'
import { Flex, Select } from 'antd'
import PatternIcon from '../../../../components/common/PatternIcon'

const FinetunePatternSelect = props => {
    const fineTunedPattens = useSelector(patternSelectors.fineTunedPatterns)

    const patternOptions = fineTunedPattens?.map(pattern => ({
        value: pattern.motif_id,
        label: (
            <Flex gap={8} align='center'>
                <PatternIcon id={pattern.motif_id} colorId={pattern.color_id} />
                {pattern.motif_caption}
            </Flex>
        ),
    }))

    return (
        <Select
            options={patternOptions}
            optionLabelProp='label'
            showSearch
            notFoundContent='There are no finetuned patterns'
            placeholder='Select a pattern'
            popupMatchSelectWidth={false}
            getPopupContainer={triggerNode => triggerNode.parentNode}
            optionFilterProp='label'
            {...props}
        />
    )
}

export default FinetunePatternSelect
